export default {
    props: {
        notification: Object,
        highlight: Boolean,
        canRead: {
            default: false,
            Boolean,
        }
    },

    methods: {
        markAsRead() {
            if (this.notification.read_at) {
                return
            }

            axios.post('/notifications/mark-as-read', {
                id: this.notification.id
            }).then(() => Quiz.$emit('notification-read', this.notification));
        }
    }
}